import { ReactNode, useEffect } from 'react';
import dayjs from 'dayjs';
import { useRouter } from 'next/router';
import { IntlProvider as NextIntlProvider } from 'next-intl';

type PropsType = {
  children: ReactNode;
  messages?: any;
};

export const IntlProvider = ({ children, messages }: PropsType) => {
  const router = useRouter();
  const locale = router.locale || router.defaultLocale || 'uz';

  useEffect(() => {
    const lang = locale === 'uz' ? 'uz-latn' : locale;

    dayjs.locale(lang);
  }, [locale]);

  return (
    <NextIntlProvider locale={locale} messages={messages} timeZone="Asia/Tashkent">
      {children}
    </NextIntlProvider>
  );
};
